<scope-roles-header
  *ngIf="department.roles?.length > 0 && !config?.isTimeline"
  [config]="config"
  [level]="level">
</scope-roles-header>

<scope-roles-row
  *ngFor="let role of department.roles | orderBy: 'order'; trackBy: trackById"
  [role]="role"
  [config]="config"
  [component]="component"
  [level]="level"
  (onOverrideRateCardRoleHours)="onOverrideRateCardRoleHours.emit($event)"
  (onUpdateRole)="onUpdateRole.emit($event)">
</scope-roles-row>
